export default "<h1>Unauthorized</h1>\n";